import client from './client'

async function listNotifiers () {
  const response = await client.get('notifiers')
  if (response.status === 200) {
    return { notifiers: response.data }
  }
  return null
}

async function createNotifier ({ serviceID, type, webHooks }) {
  const response = await client.post('notifiers', {
    serviceID,
    type,
    webHooks
  })
  if (response.status === 201) {
    return {
      status: 'OK'
    }
  }
  return null
}

async function updateNotifier ({ id, serviceID, type, webHooks }) {
  const response = await client.put(`notifiers/${id}`, {
    serviceID,
    type,
    webHooks
  })
  if (response.status === 201) {
    return {
      status: 'OK'
    }
  }
  return null
}

async function deleteNotifier ({ id }) {
  const response = await client.delete(`notifiers/${id}`)
  if (response.status === 204) {
    return {
      status: 'OK'
    }
  }
  return null
}

export default {
  listNotifiers,
  createNotifier,
  updateNotifier,
  deleteNotifier
}
